import { render, staticRenderFns } from "./CatalogueOfArchives.vue?vue&type=template&id=63781d3e"
import script from "./CatalogueOfArchives.vue?vue&type=script&lang=js"
export * from "./CatalogueOfArchives.vue?vue&type=script&lang=js"
import style0 from "./CatalogueOfArchives.vue?vue&type=style&index=0&id=63781d3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports